/* Brand panel with overlapping image ( https://tailwindui.com/components/marketing/sections/cta-sections#component-8403e31b9d3a3ca6757f0a7bbb926cd0 ) */

import React from "react";
import SbEditable from "storyblok-react";
import RichText from "src/utils/RichText";
import Button from "src/components/Button";
import Heading from "src/components/Heading";
import { BackgroundColour } from "src/utils/ColourUtilities";
import BrandLogo from "src/utils/BrandLogo";
import FluidImage from "src/utils/FluidImage";

const BrandPanelOverlappingImage = ({ blok }) => {

  return (
    <SbEditable content={blok} key={blok._uid}>
      <div className="relative my-16 bg-white">
        <div
          className={`max-w-7xl mx-auto ${BackgroundColour(
            blok.colour
          )} lg:bg-transparent lg:px-8`}
        >
          <div className="lg:grid lg:grid-cols-12">
            <div
              className={`relative z-10 ${
                blok.flip_content ? "lg:col-start-9" : "lg:col-start-1"
              } lg:row-start-1 lg:col-span-4 lg:py-16 lg:bg-transparent`}
            >
              <div
                className="absolute inset-x-0 h-1/2 bg-gray-50 lg:hidden"
                aria-hidden="true"
              />
              <div className="max-w-md mx-auto px-4 sm:max-w-3xl sm:px-6 lg:max-w-none lg:p-0">
                <div className="relative">
                  <div className="">
                    <FluidImage className="object-cover object-center shadow-2xl" image={blok.image} />
                  </div>
                  {!blok.remove_image_icon &&
                    <div className="w-100 h-100 absolute flex justify-center items-center inset-0">
                      <div className={`bg-${blok.colour} py-5 px-8 bg-opacity-80 ${["teal", "mustard", "darkorange", "darkblue"].includes(blok.colour) ? "block" : "hidden"}`}>
                        <BrandLogo colour={blok.colour} />
                      </div>
                    </div>
                  }
                </div>
              </div>
            </div>

            <div
              className={`relative ${BackgroundColour(blok.colour)} ${
                blok.flip_content ? "lg:col-start-1" : "lg:col-start-3"
              } lg:row-start-1 lg:col-span-10 lg:grid lg:grid-cols-10 lg:items-center`}
            >
              <div
                className={`relative max-w-md mx-auto py-12 px-4 sm:max-w-3xl sm:py-16 sm:px-6 lg:max-w-none lg:p-0 ${
                  blok.flip_content ? "lg:col-start-1" : "lg:col-start-4"
                } lg:col-span-6`}
              >
                <Heading size="h2" className="text-white mb-1">
                  {blok.title}
                </Heading>
                <span className="text-xs text-white block mt-0 mb-6 italic">
                  {blok.sub_title}
                </span>
                <span className="text-sm text-white font-body block max-w-md mb-4">
                  <RichText>{blok.content}</RichText>
                </span>
                <Button
                  className="bg-red hover:bg-darkred mt-4"
                  target={blok.button_url.cached_url}
                >
                  {blok.button_label}
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </SbEditable>
  );
};

export default BrandPanelOverlappingImage;
